import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API, api } from "@/lib/api";

export interface ShopItem { id: string; name: string; title: string; price: number; section: string; season?: string; product_type?: string; collection?: string; categories: string[]; etsy_url?: string | null; has_thumb: boolean }

let cache: ShopItem[] | null = null;

export function useListings() {
  const [items, setItems] = useState<ShopItem[] | null>(cache);
  useEffect(() => {
    if (!cache) api.get("/public/listings").then((r) => { cache = r.data; setItems(r.data); }).catch(() => setItems([]));
  }, []);
  return items;
}

export function ShopGrid({ items }: { items: ShopItem[] }) {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="shop-grid">
      {items.map((i, n) => (
        <Link key={i.id} to={`/shop/${i.id}`} className="calm-card group block overflow-hidden fade-up" style={{ animationDelay: `${n * 50}ms` }} data-testid={`shop-item-${i.id}`}>
            {i.has_thumb && <img src={`${API}/public/thumb/${i.id}`} alt={i.name} className="aspect-[5/4] w-full object-cover" loading="lazy" />}
            <div className="flex items-start justify-between gap-3 p-4">
              <p className="font-heading text-lg font-semibold leading-tight text-[#23324A]">{i.name}</p>
              <p className="font-heading text-lg font-semibold text-[#D9785C]">${i.price.toFixed(2)}</p>
            </div>
            <p className="px-4 pb-4"><span className="pill" data-testid={`shop-instant-${i.id}`}>Instant download</span></p>
        </Link>
      ))}
    </div>
  );
}
